export default __webpack_public_path__ + "static/media/programme-hearing-aid.7b11b563.svg";